import { useEffect } from 'react';
import { tracking } from '#action/tracking';

const useTracking = () => {
  useEffect(() => tracking(), []);
};

export default useTracking;
